import Ajv from "ajv";
import addFormats from "ajv-formats";
import addErrors from "ajv-errors";
import { registerI18nKeywords } from "@congrs/schemas";

const ajv = new Ajv({
  allErrors: true,
  verbose: true,
  $data: true,
  strict: false,
});

addFormats(ajv);
addErrors(ajv);
registerI18nKeywords(ajv);

export default ajv;
